import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getallUser } from '../../actions'
import MUIDataTable from 'mui-datatables'
import { useState } from 'react'
import NotificationForm from './NotificationForm'

const options = {
    filter: false,
    viewColumns: false,
    print: false,
    download: false,
    search: false,
    selectableRows: 'none',
}

const Notification = () => {
    const dispatch = useDispatch()
    const [selectedUsers, setSelectedUsers] = useState([])
    const [showForm, setShowForm] = useState(false)
    const [searchInput, setSearchInput] = useState('')
    const [filteredUser, setFilteredUser] = useState([])

    const onChangeHandler = value => {
        if(selectedUsers.includes(value)) setSelectedUsers(selectedUsers?.filter(val => val !== value))
        else setSelectedUsers([...selectedUsers, value])
    }

    const columns = [
        {
            name: 'userId',
            label: 'Select',
            options: {
                filter: true,
                sort: true,
                customBodyRender: (status) => {
                    return (
                        <input type="checkbox" className='select-user' onChange={e => onChangeHandler(status)}/>
                    )
                },
                setCellProps: () => ({ style: { width: '50px' } }) // Set width here
    
            },
        },
        {
            name: 'username',
            label: 'User Name',
            options: {
                filter: false,
                sort: true,
            },
        }, 
        {
            name: 'firstName',
            label: 'First Name',
            options: {
                filter: false,
                sort: true,
            },
        }, 
        {
            name: 'lastName',
            label: 'Last Name',
            options: {
                filter: false,
                sort: true,
            },
        }, 
        {
            name: 'mobileNumber',
            label: 'Mobile',
            options: {
                filter: false,
                sort: true,
            },
        }, 
    ]
    
    useEffect(() => {
        dispatch(getallUser())
    },[])

    const allUserList = useSelector(state => state.home.userList)

    useEffect(() => {
        setFilteredUser(allUserList)
    },[allUserList])

    useEffect(() => {

        const filtered = filteredUser?.filter((val) => {
            if(searchInput == ''){
                return val
            }else if(val?.firstName?.toLowerCase()?.includes(searchInput?.toLowerCase()) || 
                        val?.lastName?.toLowerCase()?.includes(searchInput?.toLowerCase()) || 
                        val?.username?.toLowerCase()?.includes(searchInput?.toLowerCase()) || 
                        val?.mobileNumber?.toLowerCase()?.includes(searchInput?.toLowerCase())){
                return val
            }
        })
        setFilteredUser(filtered)

        if(searchInput?.length < 3){
            setFilteredUser(allUserList)
        }

    },[searchInput])

    const onAddHandler = () => {
        setShowForm(true)
    }

  return (
    <div className='pcoded-inner-content'>
        {showForm ? <NotificationForm selectedUsers={selectedUsers} setShowForm={setShowForm}/> :
        <div className="main-body">
            <div className="page-wrapper">
                <div className="row">
                    <div className="col-sm-12">
                        <div className="card">
                            <div className="card-block">
                                <div className="card-header">
                                    <h5>Notification</h5>
                                    <span style={{color:'white'}} onClick={onAddHandler} className="btn btn-sm btn-inverse waves-effect waves-light f-right d-inline-block md-trigger" ><i className='icofont icofont-plus m-r-5'></i>Create Notification</span>
                                </div>
                                <div className='col-sm-12'>
                                    <input type="text" onChange={e=>setSearchInput(e.target.value)} className='form-control' placeholder='Search for User'/>
                                </div>
                                <div className="dt-responsive table-responsive">
                                    <MUIDataTable className="table-responsive" columns={columns} options={options} data={filteredUser}/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>}
    </div>
  )
}
 
export default Notification